<template>
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.3203 18.97C10.4603 19.08 10.6003 19.18 10.7503 19.29C11.8903 20.12 13.0403 20.78 14.1903 21.27C15.3403 21.76 16.4303 22 17.4503 22C18.1503 22 18.8003 21.87 19.4003 21.62C20.0103 21.37 20.5503 20.98 21.0403 20.44C21.3303 20.12 21.5503 19.78 21.7203 19.42C21.8903 19.06 21.9703 18.69 21.9703 18.33C21.9703 18.05 21.9103 17.8 21.8103 17.55C21.7003 17.3 21.5203 17.09 21.2603 16.91L17.9503 14.56C17.7003 14.39 17.4703 14.26 17.2503 14.17C17.0303 14.08 16.8303 14.04 16.6403 14.04C16.3903 14.04 16.1603 14.11 15.9303 14.25C15.7003 14.37 15.4603 14.56 15.2103 14.81L14.4503 15.56C14.3403 15.67 14.2103 15.73 14.0403 15.73C13.9503 15.73 13.8703 15.72 13.7903 15.69C13.7203 15.66 13.6603 15.63 13.6103 15.61C13.4203 15.51 13.2003 15.37 12.9603 15.19"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      stroke-width="1.5"
    />
    <path
      d="M10.73 13.22C10.21 12.69 9.73 12.16 9.28 11.64C8.84 11.12 8.53 10.69 8.35 10.36C8.33 10.3 8.3 10.24 8.27 10.16C8.25 10.08 8.24 10.01 8.24 9.93C8.24 9.77 8.29 9.64 8.4 9.53L9.16 8.74C9.4 8.5 9.59 8.26 9.72 8.03C9.86 7.8 9.93 7.56 9.93 7.32C9.93 7.13 9.88 6.92 9.79 6.71C9.7 6.49 9.57 6.26 9.39 6.01L7.07 2.74C6.89 2.48 6.66 2.3 6.4 2.18C6.15 2.06 5.87 2 5.59 2C4.85 2 4.15 2.31 3.51 2.94C2.98 3.44 2.6 4 2.36 4.61C2.12 5.21 2 5.86 2 6.54C2 7.58 2.24 8.67 2.72 9.81C3.2 10.94 3.86 12.08 4.68 13.22C5.51 14.36 6.44 15.45 7.47 16.49"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      stroke-width="1.5"
    />
    <path
      d="M22 2L2 22"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
  </svg>
</template>
